import React, { Component, Fragment } from 'react'
import { postEval } from '../../services/api-services/evaluasi-api';
import swal from 'sweetalert';

export default class PertanyaanNonDosen extends Component {

    constructor(props) {
        super(props)
        this.state = {
            dataAnswer: [],
            isLoading: false
        }
    }

    handleInput = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    };

    handleAnswer = (event) => {
        const bobot = event.target.value
        const id = event.target.name

        // Periksa apakah nilai yang dipilih sudah ada dalam array data
        const data = this.state.dataAnswer;
        const existingItemIndex = data.findIndex(item => item.idpertanyaan === id);

        if (existingItemIndex !== -1) {
            // Perbarui item yang sudah ada
            const updatedData = [...data];
            updatedData[existingItemIndex].bobot = bobot;
            this.setState({ dataAnswer: updatedData });
        } else {
            // Tambahkan item baru ke dalam array data
            const newItem = { idpertanyaan: id, bobot: bobot };
            this.setState({
                dataAnswer: [
                    ...this.state.dataAnswer,
                    newItem
                ]
            })
        }
    }

    postAnswer = async (e) => {
        e.preventDefault();
        this.setState({ isLoading: true }); 

        const dataForm = {
            nim: this.props.dataMhs.nim,
            idjadwal: '',
            idfakultas: this.props.dataMhs.idfakultas,
            ta: this.props.akademik.ta,
            smtta: this.props.akademik.smtta,
            semester: this.props.akademik.semester,
            komentar: this.state.komentar,
            data: this.state.dataAnswer
        };

        try {
            const res = await postEval(dataForm, this.props.idjenis);
            if (res.status === 200) {
                this.props.refresh(e);
                swal({
                    icon: 'success',
                    title: 'Berhasil',
                    text: 'Data telah disimpan'
                });
            }
        } catch (error) {
            swal({
                icon: 'error',
                title: 'Gagal',
                text: 'Terjadi kesalahan saat menyimpan data'
            });
        } finally {
            this.setState({ isLoading: false });
        }
    }


    render() {        
        return (
            <div className="card card-custom mb-3 pl-3 pr-3">
                <div className="card-body">
                    <p className="card-title text-center mb-4" style={{ fontSize: '25px', marginTop: '10px' }}>Kuisioner {this.props.jenis}</p>
                    {
                        this.props.akademik.validasi == "SudahDiisi" ?
                            <div className="alert alert-success text-white" role="alert">
                                Hai... Kuisioner kamu sudah selesai, semoga kamu menemukan karir dan jodoh yang cocok &nbsp;&#10084;
                            </div>
                            :
                            <form id="dataTambah" onSubmit={this.postAnswer}>
                                <div className="table-responsive mt-3" id="">
                                    <table id="" className="display expandable-table table-striped" style={{ width: '100%' }}>
                                        <tbody>
                                            {
                                                this.props.data.length !== 0 ? this.props.data.map((list, i) => {
                                                    return (
                                                        <Fragment key={i}>
                                                            <tr>
                                                                <td>{i + 1}. {list.pertanyaan}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <input type='radio' name={list.idpertanyaan} onChange={this.handleAnswer} value='1' required /> <label>{list.bobot1}</label>
                                                                    <br />
                                                                    <input type='radio' name={list.idpertanyaan} onChange={this.handleAnswer} value='2' required /> <label>{list.bobot2}</label>
                                                                    <br />
                                                                    <input type='radio' name={list.idpertanyaan} onChange={this.handleAnswer} value='3' required /> <label>{list.bobot3}</label>
                                                                    <br />
                                                                    <input type='radio' name={list.idpertanyaan} onChange={this.handleAnswer} value='4' required /> <label>{list.bobot4}</label>
                                                                    <br />
                                                                    <input type='radio' name={list.idpertanyaan} onChange={this.handleAnswer} value='5' required /> <label>{list.bobot5}</label>
                                                                </td>
                                                            </tr>
                                                        </Fragment>
                                                    )
                                                }) : <tr><td colSpan="8"><center>  Tidak ada data </center></td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                {
                                    this.props.data.length != 0 ?
                                        <>
                                            <input type='text' className="form-control" name="komentar" onChange={this.handleInput}
                                                placeholder="Komentar & Saran" required />
                                            <p className='mt-3' align="right">
                                                <button type="submit" className="btn btn-primary" disabled={this.state.isLoading}>
                                                    {this.state.isLoading ? "Loading..." : "Simpan"}
                                                </button>
                                            </p>
                                        </>
                                        : null
                                }
                            </form>
                    }
                </div>
            </div>
        )
    }
}

